import { render } from "./z-table.vue?vue&type=template&id=1b60b5bc"
import script from "./z-table.vue?vue&type=script&lang=js"
export * from "./z-table.vue?vue&type=script&lang=js"

import "./z-table.vue?vue&type=style&index=0&id=1b60b5bc&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__